export function formatUserName(
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
): string {
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();
  return fullName || email || "Unknown User";
}

export function formatDate(dateString?: string | null): string {
  if (!dateString) return "Unknown";

  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function getStatusLabel(
  hasIntegrations: boolean,
  count: number,
): string {
  if (!hasIntegrations) return "Not Connected";
  return count > 1 ? `${count} Connected` : "Connected";
}

export interface IntegrationInstance {
  id: string;
  name: string;
  enabledBy: {
    name: string;
    avatar?: string;
  };
  enabledOn: string;
}

export interface InputField {
  id: string;
  label: string;
  type: "text" | "password" | "url";
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  required: boolean;
}

export interface IntegrationConfig {
  name: string;
  icon: React.ReactNode;
  description: string;
  carouselImages: Array<{ src: string; alt: string }>;
  inputs: InputField[];
  setupDescription: React.ReactNode;
}

export type IntegrationStatus = "connected" | "disconnected";
